import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetCustomer(id: string | undefined) {
  return useQuery(queries.customers.getCustomerById(id || ''))
}
